import { Alert, Button, Chip, CircularProgress, Container } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import { STATUS_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import StatusDialog from "./StatusDialog";
import { useAlert } from "../alerts/AlertContext";

const statusColors = {
  open: "#007BFF",
  "in-progress": "#FD7E14",
  hold: "#FFC107",
  resolved: "#20C997",
  closed: "#6C757D",
};

function Status() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const showAlert = useAlert();

  const getStatus = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get(STATUS_URL);
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching statuses:", error);
      setError("Failed to load statuses. Please try again.");
      // showAlert("Failed to load statuses", "error");
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  const columns = [
    {
      field: "seq",
      flex: 1,
      headerName: "Sequence",
      renderCell: (params) => params.value,
    },
    {
      field: "name",
      flex: 2,
      headerName: "Status Name",
      renderCell: (params) => (
        <Chip
          label={params.value}
          color="primary"
          sx={{
            backgroundColor: statusColors[params.value.toLowerCase()],
            color: "white",
          }}
          size="small"
        />
      ),
    },

    {
      field: "active",
      flex: 1,
      headerName: "Active",
      renderCell: (params) => (
        <Chip
          label={params.value ? "Active" : "Inactive"}
          color={params.value ? "success" : "default"}
          size="small"
          sx={{
            borderRadius: 1,
            fontWeight: 500,
            minWidth: 70,
          }}
        />
      ),
    },
    {
      field: "action",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <StatusDialog
            editStatusId={params.row.id}
            statusName="Edit"
            variant="link"
          />
        </Box>
      ),
    },
  ];

  //if error content
  if (error) {
    return (
      <Container>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={getStatus}>
              Retry
            </Button>
          }
          sx={{ borderRadius: 2 }}
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {/* loading or content */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <AppTableView rows={data} cols={columns} initialPageSize={5} />
      )}
    </Box>
  );
}

export default Status;
